import type { SearchSnippet } from "@/api/client";
import { splitHighlight } from "@/lib/highlight";

/**
 * A search snippet with its matches in `<mark>`. The text is raw user input and
 * goes into the DOM as text nodes only — the `<mark>` is the sole markup, and it
 * is ours.
 */
export function Highlighted({ snippet }: { snippet: SearchSnippet }) {
  return (
    <>
      {splitHighlight(snippet.text, snippet.ranges ?? []).map((part, i) =>
        part.hit ? <mark key={i}>{part.text}</mark> : part.text,
      )}
    </>
  );
}
